
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  PropType,
  Ref
} from "vue";
import { getNomePessoaAntt } from "../../../modules/business/rntrc/pessoa/pessoaAnttBusiness";
import { VeiculoAnttPayload } from "../../../modules/business/rntrc/veiculo/veiculoAnttBusiness";
import {
  formatPlaca,
  getServicoVeiculoLabel
} from "../../../modules/business/rntrc/rntrcTypes";

interface BuscaVeiculoAnttState {
  placa: string;
  stateReady: boolean;
  stateId: string;
  loadings: Array<Ref<boolean>>;
}

/**
 * Consulta de veículos da tela de serviço, em pop-up como a consulta de veículos da licença:
 * filtro de placa, seleção de várias placas e Confirmar. A busca (ANTT + GovPass do cliente) e
 * os resultados ficam na tela que abre; aqui só filtro, seleção e os atalhos de cadastro.
 */
export default defineComponent({
  setup(props, { emit }) {
    const state = reactive<BuscaVeiculoAnttState>({
      placa: "",
      stateReady: false,
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2),
      loadings: []
    });

    const submitSearch = () => {
      emit("buscar", state.placa);
    };

    const clearFilter = () => {
      state.placa = "";
      emit("buscar", "");
    };

    const confirmSelection = (selecionados: Array<VeiculoAnttPayload>) => {
      emit("confirm-selection", selecionados ?? []);
    };

    const cancelSelection = () => {
      emit("cancel-selection");
    };

    const abrirCadastro = (
      idVeiculoAntt: number | null,
      placa: string | null
    ) => {
      emit("abrir-cadastro", idVeiculoAntt, placa);
    };

    onMounted(() => {
      state.placa = props.placaInicial ?? "";
      state.stateReady = true;
    });

    return {
      submitSearch,
      clearFilter,
      confirmSelection,
      cancelSelection,
      abrirCadastro,
      formatPlaca,
      getServicoVeiculoLabel,
      getNomePessoaAntt,
      ...toRefs(state)
    };
  },
  props: {
    resultados: Array as PropType<Array<VeiculoAnttPayload>>,
    carregando: Boolean,
    placaInicial: String,
    /** Motivo que impede marcar a placa (já adicionada, sem CRLV, só na GovPass...). */
    blockedSelection: Function as PropType<
      (v: VeiculoAnttPayload) => string | boolean
    >,
    /** IMF: a placa é de outro proprietário que não o da inclusão? */
    outroProprietario: Function as PropType<(v: VeiculoAnttPayload) => unknown>
  },
  emits: ["buscar", "confirm-selection", "cancel-selection", "abrir-cadastro"]
});
